import React from 'react';
import Routes from './routes';

// Components
import Footer from './components/Footer';

function App() {
  return (
    <div>
      <Routes/>
      <Footer/>
    </div>
  );
}

export default App;
